<template>
  <div class="header-wrap" :class="fixed ? 'fixed' : ''">
    <!-- 返回键 -->
    <span class="return-btn">
      <van-icon name="arrow-left" v-if="showBack" @click="backPrev()"></van-icon>
    </span>
    <div class="header-title-text">{{title}}</div>
    <!--编辑按钮-->
    <span class="edit-btn" @click="edit" v-if="showEdit">{{ edits ? '取消': '编辑'}}</span>
    <span class="edit-btn" v-else></span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchStr: "",
      fixed: false,
      edits: false
    };
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    showBack: {
      type: Boolean,
      default: false
    },
    showEdit: {
      type: Boolean,
      default: false
    },
    isBack: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    backPrev() {
      this.edits = false;
      if(this.isBack) {
        if(window.history.length > 1) {
          this.$router.go(-1);
        } else {
          this.$router.push({
            name: 'home'
          })
        }
      
      } else {
        this.$emit('handlerBack')
      }   
    },
    getStr() {
      this.$emit("handlerStr", this.searchStr);
    },
    edit() {
      this.edits = !this.edits;
      this.$emit("handlerEdit", this.edits);
    }
  },
  watch: {
    isEdit(val) {
      this.edits = val
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/base.scss";
.header-wrap {
  width: 100%;
  max-width: 750px;
  height: 88px;
  background: $bg02;
  display: flex;
  text-align: center;
  line-height: 98px;
  padding: 0 30px 0 25px;
  position: fixed;
  top:0;
  z-index: 666;
  border-bottom: 1px solid #ccc;
  .input-box {
    display: flex;
    width: 620px;
    height: 68px;
    border-radius: 34px;
    padding-left: 30px;
    padding-right: 30px;
    margin-left: -310px;
    background: rgba(255, 255, 255, 1);
    left: 50%;
    top: 10px;
    box-shadow: 2px 2px 16px rgba(0, 0, 0, 0.08);
    z-index: 999;
    position: absolute;
    .search-btn {
      width: 40px;
      height: 100%;
      background-image: url("../assets/images/search-icon.png");
      background-size: 40px 40px;
      background-repeat: no-repeat;
      background-position: 0 14px;
    }
    input {
      flex: 1;
      font-size: 28px;
      color: $fc03;
      padding-left: 10px;
      background: none;
    }
    /*input::-webkit-input-placeholder{*/
    /*  line-height: 68px;*/
    /*}*/
  }

  .return-btn {
    width: 60px;
    height: 88px;
    line-height: 110px;
    font-size: 42px;
    color: #666;
    text-align: left;
    &:active {
      color: $fc07;
    }
  }
  .header-title-text {
    display: block;
    line-height: 98px;
    text-align: center;
    font-size: 36px;
    color: $fc03;
    flex: 1;
  }
  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .edit-btn {
    display: block;
    width: 60px;
    height: 100%;
    line-height: 100px;
    font-size: 28px;
    color: $fc03;
    &:active{
      color: $fc07
    }
  }
}
</style>


